import { initFelix2021 } from '../charity-2021/felixPristine'

document.addEventListener('DOMContentLoaded', function () {
    initFelix2021();
});